import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './views/Home';
import Access from './views/Access';
import Demographics from './views/Demographics';
import { hasAccess, hasFullAccess } from './utils/access';
import TopBanner from './components/TopBanner'
import { isEOD } from './utils/cookies';
import EndOfDay from './views/EndOfDay';

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    hasAccess()
      .then((isAccess) => {
        if (isAccess) {
            hasFullAccess()
                .then((isFullAccess) => {
                    if (isFullAccess) {
                        if (isEOD()) {
                            navigate("/endofday", { replace: true });
                        } else {
                            navigate("/home", { replace: true });
                        }
                    } else {
                        navigate("/demographics", {replace: true});
                    }
                })
        }
        else {
            navigate("/", { replace: true });
        }
      })
  }, [navigate]);

  return (
    <div>
        <TopBanner/>
        <Routes>
            <Route path="/" element={<Access />} />
            <Route path="/home" element={<Home />} />
            <Route path="/demographics" element={<Demographics/>} />
            <Route path="/endofday" element={<EndOfDay/>} />
        </Routes>
    </div>
  );
}

function AppWrapper() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

export default AppWrapper;
